import { ORDER_BY } from 'constants/paginationOrder';
import { isMobile } from 'util/screen';
import {
  FETCH_REVIEWS,
  FETCH_REVIEWS_SUCCESS,
  FETCH_REVIEWS_FAILED,
  SET_REVIEWS_PARAMS,
  CREATE_REVIEW,
  SET_REVIEWS_STATS,
  CLEAN_LIST_OF_REVIEWS,
} from 'store/actions/reviews/type';

export const initialState = {
  listOfReviews: {
    params: {
      page: 1,
      size: 10,
      orderBy: isMobile() ? ORDER_BY.DESC : ORDER_BY.ASC ,
      order_field: isMobile() ? 'createdAt' : '',
    },
    totalPages: 1,
    totalElements: 10,
    results: {
      list: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    },
  },
  createReviews: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: [],
  },
  stats: {
    score: '',
    totalReviews: 0,
    ratings: [],
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REVIEWS:
      return {
        ...state,
        listOfReviews: {
          ...state.listOfReviews,
          results: {
            ...state.listOfReviews.results,
            loading: false,
            success: false,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_REVIEWS_SUCCESS:
      return {
        ...state,
        listOfReviews: {
          ...state.listOfReviews,
          params: {
            ...state.listOfReviews.params,
            ...action.payload.params,
          },
          totalPages:
            action.payload.totalPages || state.listOfReviews.totalPages,
          totalElements:
            action.payload.totalElements || state.listOfReviews.totalPages,
          results: {
            ...state.listOfReviews.results,
            list: action.payload.incrementalList
              ? state.listOfReviews.results.list.concat(action.payload.list)
              : action.payload.list,
            loading: false,
            success: true,
            error: false,
            errorMessage: '',
          },
        },
        stats: {
          ...state.stats,
          ...action.payload.stats,
        },
      };
    case FETCH_REVIEWS_FAILED:
      return {
        ...state,
        listOfReviews: {
          ...state.listOfReviews,
          results: {
            ...state.listOfReviews.results,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload,
          },
        },
      };
    case SET_REVIEWS_PARAMS:
      return {
        ...state,
        listOfReviews: {
          ...state.listOfReviews,
          params: {
            ...state.listOfReviews.params,
            ...action.payload,
          },
        },
      };
    case CREATE_REVIEW:
      return {
        ...state,
        createReviews: {
          success: false,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
      };
    case SET_REVIEWS_STATS:
      return {
        ...state,
        stats: {
          ...state.stats,
          ...action.payload,
        },
      };
    case CLEAN_LIST_OF_REVIEWS:
      return {
        ...state,
        listOfReviews: initialState.listOfReviews,
      };
    default:
      return state;
  }
};
